import React from 'react'
import { Link } from 'react-router-dom'

import {
  formatEventSchedule,
  timezones,
  getUrl,
} from '../../../utilities/helpers'

import Stack from 'react-bootstrap/Stack'

import placeholder from '../../../assets/placeholder.png'

import './searchItem.scss'

export default function SearchItem({ event }) {
  let timezone = timezones(event?.venue?.timezone)
  const soldOut = Boolean(event?.soldOut)
  const content = (
    <>
      <img
        width="48"
        height="48"
        className="event-image thumbnail"
        alt={event?.name}
        src={event?.image?.url || placeholder}
      />
      <Stack className="details-info">
        {soldOut ? <span className="sold-out-badge">Sold out</span> : null}
        <p className="details-info-event-name">{event?.name}</p>
        <span className="search-item-meta small text-muted text-left">
          {formatEventSchedule(event, timezone)} | {event?.venue.name}
        </span>
      </Stack>
    </>
  )

  if (soldOut) {
    return (
      <li className="search-item search-item--sold-out text-left">
        <div className="d-flex gap-3 align-items-center">{content}</div>
      </li>
    )
  }

  return (
    <li className="search-item text-left">
      <Link
        to={`${getUrl(`/e/${event?.seoUrl}/${event?.shortCode}`, event?.seatmap?.ga_only)}`}
        className="d-flex gap-3 align-items-center"
      >
        {content}
      </Link>
    </li>
  )
}
